import React from "react";
import styles from "./TextInput.module.scss";
import { observer } from "mobx-react";
import { TextareaAutosize } from "@material-ui/core";

type TTextAreaInput = {
  value: string;
  onChange?: (v: string) => void;
  onClick?: () => void;
  placeholder: string;
  error?: string;
  dataIcon?: string;
  maxLength: number;
};

const TextAreaInput: React.FC<TTextAreaInput> = observer(
  ({ value, onChange, placeholder, error, onClick, maxLength, dataIcon }) => {
    const onTextChange = (e) => {
      if (typeof onChange === "function") {
        onChange(e.target.value);
      }
    };

    return (
      <div className={styles.TextAreaInputContainer}>
        <div className={styles.TextAreaInputContainer_Wrapper}>
          <TextareaAutosize
            onClick={onClick}
            data-error={!!error}
            value={value}
            onChange={onTextChange}
            placeholder={placeholder}
            className={styles.TextAreaInputContainer_Input}
            data-icon={dataIcon}
            maxLength={maxLength}
          />
          <div className={styles.TextAreaInputContainer_Counter}>
            {`${value.length}/${maxLength}`}
          </div>
        </div>
        {error && (
          <div className={styles.TextAreaInputContainer_Error}>{error}</div>
        )}
      </div>
    );
  }
);

export default TextAreaInput;
